import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  LOCALE_STORAGE_KEY,
  applyLanguageSideEffects,
  fallbackLocale,
  supportedLocaleCodes,
} from './i18n/locales';

const LOCALES_VERSION = '2026-06-23-night-actions';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLocaleCodes,
    fallbackLng: fallbackLocale,
    load: 'languageOnly',
    returnEmptyString: false,
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
    },
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${LOCALES_VERSION}`,
      requestOptions: {
        cache: 'no-store',
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (language) => {
  applyLanguageSideEffects(language);
});

applyLanguageSideEffects(i18n.resolvedLanguage || i18n.language);

export default i18n;
